import { useMutation, useQueryClient } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useAddSnippet = () => {
  const queryClient = useQueryClient();
  return useMutation(caseNestService.addSnippet, {
    onMutate: async (addSnippet) => {
      const queryKey = [queryKeys.snippets, addSnippet?.caseTypeId];
      await queryClient.cancelQueries(queryKey);
      const snapshotOfPreviousSnippets = queryClient.getQueryData(queryKey);

      if (snapshotOfPreviousSnippets) {
        queryClient.setQueryData(queryKey, (oldSnippets) =>
          oldSnippets?.data ? [...oldSnippets?.data, addSnippet] : [addSnippet]
        );
      }
      return {
        snapshotOfPreviousSnippets,
      };
    },

    onError: (error, addSnippet, { snapshotOfPreviousSnippets }) => {
      queryClient.setQueryData([queryKeys.snippets, addSnippet?.caseTypeId], snapshotOfPreviousSnippets);
    },

    onSuccess() {
      queryClient.invalidateQueries(queryKeys.snippets);
    },
  });
};

export default useAddSnippet;
